import { piwikPrefix } from './gtm-service';

export const pushCustomToPiwikDataLayer = <T>(dimensions: GenericCustomDimensionInterface<T>) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'set-custom-dimensions',
        ...dimensions,
    });
};

export const pushActionToPiwikDataLayer = <T>(dimensions: GenericCustomDimensionInterface<T>) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'custom',
        app_namespace: piwikPrefix,
        ...dimensions,
    });
};

interface GenericCustomDimensionInterface<T> {
    [key: string]: T | undefined;
}

export interface CustomActionDimension<T> extends GenericCustomDimensionInterface<T> {
    action: T;
    action_value: T;
}
export function createActionVerdivurdering() {
    const bestillVerdivurdering: CustomActionDimension<string> = {
        action: 'kreditt_bestill_verdivurdering',
        action_value: 'verdivurdering_boliglaan',
    };
    pushActionToPiwikDataLayer(bestillVerdivurdering);
}
